export class MainNavigationLink {
    routerLinkValue: string | string[] | [string, { outlets: { [key:string]: string[] } }]; // ['/home'] or [{ outlets: { secondOutlet: ['details', item.id] } }]
    labelText?: string | undefined; // 'My profile'
    labelLanguageKey?: string; // 'common.login'
    condition?: string; // 'hideIfNoUser'
    selected?: boolean
}